var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{ref:"dialog",attrs:{"custom-class":"bg-wh tx-c box-shadow-none"}},[_c('img',{attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }